import { render, staticRenderFns } from "./ProductCustomizer.vue?vue&type=template&id=3e126d6b&v-if=isReady"
import script from "./ProductCustomizer.vue?vue&type=script&lang=ts"
export * from "./ProductCustomizer.vue?vue&type=script&lang=ts"
import style0 from "./ProductCustomizer.vue?vue&type=style&index=0&id=3e126d6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports